/* global:
	jquery,
*/

const $ = jQuery;

import './blocks.js';
import './modules/header.js';
import './modules/bg-slant.js';
//import './modules/jqm.js';
//import './normaliseHeights.js';
import './modules/slanter.js';
import './modules/synopsisSwap.js';
import './modules/viewTabsJQ.js';
import './modules/swipe.js';
import './modules/jiggle.js';
import './modules/styleShareLinks.js';
import './modules/parallax.js';
import './cookies.js';

import { HeightMatcher } from './modules/height-matcher';

new HeightMatcher({
    containerSel: '.card-wrapper',
    itemSel: '.story',
    breakpoint: 991
});

new HeightMatcher({
    containerSel: '.card-wrapper',
    itemSel: '.story-title',
    breakpoint: 991
});

new HeightMatcher({
    containerSel: '.card-wrapper',
    itemSel: '.story-content',
    breakpoint: 991
});

// jQuery(document).ready(function() {
//   jQuery('#icon-carousel').on('swiperight swipeleft', function(e) {
//       e.type == 'swipeleft' ? jQuery('.right').click() : jQuery('.left').click();
//     });
// });
